import useLockCampaignDetails from 'queries/mutate/lockCampaignDetails';
import useFetchSpecificCampaign from 'queries/fetch/fetchSpecificCampaign.ts';
import useCampaign from './useCampaign';
import useCampaignNavigate from './useCampaignNavigate';

interface UseCampaignLockParams {
  teamId: string;
  campaignId: string;
}

const useCampaignLock = ({ teamId, campaignId }: UseCampaignLockParams) => {
  const { campaign } = useCampaign();
  const lockCampaignMutation = useLockCampaignDetails();
  const fetchSpecificCampaign = useFetchSpecificCampaign({
    teamId: teamId || '',
    campaignId: campaignId || '',
  });
  const { navigateToCampaign } = useCampaignNavigate();

  const lockCampaign = async () => {
    await lockCampaignMutation.mutateAsync({
      teamId,
      campaignId,
      newState: 'locked',
    });

    await fetchSpecificCampaign.refetch();
  };

  const unlockCampaign = async () => {
    await lockCampaignMutation.mutateAsync({
      teamId,
      campaignId,
      newState: 'unlocked',
    });

    await fetchSpecificCampaign.refetch();
  };

  const lockCampaignIfRequired = async () => {
    const lockedById = campaign?.locked_by?.id;

    if (lockedById) {
      return;
    }

    if (campaignId && campaignId !== 'new') {
      if (campaign.CampaignConfig.Name === '') {
        navigateToCampaign('/summary');
      } else {
        await lockCampaign();
      }
    }
  };

  return {
    lockCampaign,
    lockCampaignIfRequired,
    unlockCampaign,
    error: lockCampaignMutation.error || fetchSpecificCampaign.error,
    isPending: lockCampaignMutation.isPending || fetchSpecificCampaign.isFetching,
    isLoading: fetchSpecificCampaign.isLoading,
  };
};

export default useCampaignLock;
